var exports = {
  "kL": "x804f0401--76fd41--container",
  "DD": "x804f0401--76fd41--title",
};

module.exports = exports;
